import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';

interface AppConfig {
  registration_mode: string;
  email_subject: string;
  email_body: string;
}

export function useConfigQuery() {
  return useQuery<AppConfig>({
    queryKey: ['config'],
    queryFn: () => api.config.get() as Promise<AppConfig>,
    refetchInterval: 30_000,
    staleTime: 10_000,
  });
}

export function useUpdateConfig() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (updates: Record<string, string>) => api.config.set(updates) as Promise<AppConfig>,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['config'] });
    },
  });
}
